import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled/macro';
import { useUserContext } from '../../../context/userContext';
import useInput from '../../../hooks/useInput';
import Button from '../../common/button/Button';
import FormField from '../../common/formField/FormField';
import type { User } from '../../../context/userContext';
import useCustomerClient from "../../../data/customerSource";
import {useState} from "react";
import KovaUtil from "../../../kova/kovautil";
import {useCommunityContext} from "../../../context/communityContext";

const Form = styled.form`
    width: 100%;
  .buttons {
    display: flex;
    flex-direction:row;
    justify-content: space-around;
    gap: 10px;
    > * {

      flex-grow: 1;

    }
  }
    & > label {
        margin-bottom: 1rem;
    }
    & > label:last-of-type {
      margin-bottom: 0;
    }

    & button {
        margin-top: 32px;
    }
`
type RegistrationStep = "create" | "creating" | "success" | "failure";

const CreateAccount: React.FC<{searchedPhone:string, onCompleteLogin: (communityId:string) => void, onCancel: (communityId:string) => void}> = (props) => {
    const {searchedPhone, onCompleteLogin, onCancel} = props;
    const {setUser} = useUserContext();
    const [step, setStep] = useState<RegistrationStep>("create");
    const customerClient = useCustomerClient();
    const { community } = useCommunityContext();
    if (community === undefined) throw "Community missing!";

    const {onChange: OnEmailChange, value: email} = useInput('');
    const {onChange: onFirstNameChange, value: firstname} = useInput('');
    const {onChange: onLastNameChange, value: lastname} = useInput('');
    const {onChange: onPhoneChange, value: phone} = useInput(searchedPhone);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        setStep("creating");
        await customerClient.register(community, firstname, lastname, email, phone)
            .then(user => {
                setUser(user);
                onCompleteLogin(community);
            })
            .catch(reason => {
                setStep('failure');
            });
    }

    const onPhoneChangeWithValidate = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        event.preventDefault();
        event.currentTarget.value = KovaUtil.formatPhoneNumber(event.currentTarget.value);

        onPhoneChange(event)
    };

    return (
        <Form onSubmit={handleSubmit}>
            <FormField
                label="First Name"
                name="firstname"
                onChange={onFirstNameChange}
                placeholder='First Name'
                required
                type="text"
                value={firstname}
            />
            <FormField
                label="Last Name"
                name="lastname"
                onChange={onLastNameChange}
                placeholder='Last Name'
                required
                type="text"
                value={lastname}
            />
            <FormField
                label="Email"
                name="email"
                onChange={OnEmailChange}
                placeholder='Email'
                required
                type="email"
                value={email}
            />
            <div className={"buttons"}>
            {step === "failure" && <div>Failed to register. Please try again!</div>}
            {(step !== "creating") && <Button text={"cancel"} onClick={() => onCancel(community)}/>}

            {(step === "create" || step === "failure") && <Button text="confirm" type="submit" primary/>}
            {step === "creating" && <div>Submitted!</div>}
            </div>
        </Form>
    );
}

export default CreateAccount;
